// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function queryMapper(routeQuery) {
  return {
          from_address_landmark: Js_dict.get(routeQuery, "from_address_landmark"),
          from_address_lat: Js_dict.get(routeQuery, "from_address_lat"),
          from_address_long: Js_dict.get(routeQuery, "from_address_long"),
          to_address_landmark: Js_dict.get(routeQuery, "to_address_landmark"),
          to_address_lat: Js_dict.get(routeQuery, "to_address_lat"),
          to_address_long: Js_dict.get(routeQuery, "to_address_long"),
          geo_region_id: Js_dict.get(routeQuery, "geo_region_id"),
          customer_name: Js_dict.get(routeQuery, "customer_name"),
          customer_mobile: Js_dict.get(routeQuery, "customer_mobile"),
          frequency: Js_dict.get(routeQuery, "frequency"),
          brand: Js_dict.get(routeQuery, "brand"),
          is_device_mobile: Js_dict.get(routeQuery, "is_device_mobile"),
          fare_estimate_token: Js_dict.get(routeQuery, "fare_estimate_token"),
          consent_for_callback: Js_dict.get(routeQuery, "consent_for_callback"),
          utm_source: Js_dict.get(routeQuery, "utm_source"),
          utm_campaign: Js_dict.get(routeQuery, "utm_campaign"),
          utm_medium: Js_dict.get(routeQuery, "utm_medium"),
          utm_content: Js_dict.get(routeQuery, "utm_content"),
          utm_term: Js_dict.get(routeQuery, "utm_term"),
          service_category: Js_dict.get(routeQuery, "service_category")
        };
}

function isValidParams(query_params, mobileLength) {
  if (Belt_Option.isSome(query_params.fare_estimate_token) && Belt_Option.isSome(query_params.brand) && Belt_Option.isSome(query_params.customer_mobile) && Belt_Option.getWithDefault(query_params.customer_mobile, "").length === mobileLength && Belt_Option.isSome(query_params.frequency) && Belt_Option.isSome(query_params.from_address_landmark) && Belt_Option.isSome(query_params.from_address_lat) && Belt_Option.isSome(query_params.from_address_long) && Belt_Option.isSome(query_params.geo_region_id) && Belt_Option.isSome(query_params.to_address_landmark) && Belt_Option.isSome(query_params.to_address_lat) && Belt_Option.isSome(query_params.to_address_long) && Belt_Option.isSome(query_params.service_category)) {
    return Belt_Option.isSome(query_params.consent_for_callback);
  } else {
    return false;
  }
}

function isValidParamsBD(query_params) {
  return isValidParams(query_params, 10);
}

function isValidParamsUAE(query_params) {
  return isValidParams(query_params, 9);
}

function isValidParamsTR(query_params) {
  return isValidParams(query_params, 10);
}

var getDefault = {
  from_address_landmark: undefined,
  from_address_lat: undefined,
  from_address_long: undefined,
  to_address_landmark: undefined,
  to_address_lat: undefined,
  to_address_long: undefined,
  geo_region_id: undefined,
  customer_name: undefined,
  customer_mobile: undefined,
  frequency: undefined,
  brand: undefined,
  is_device_mobile: undefined,
  fare_estimate_token: undefined,
  consent_for_callback: undefined,
  utm_source: undefined,
  utm_campaign: undefined,
  utm_medium: undefined,
  utm_content: undefined,
  utm_term: undefined,
  service_category: undefined
};

export {
  getDefault ,
  queryMapper ,
  isValidParams ,
  isValidParamsBD ,
  isValidParamsUAE ,
  isValidParamsTR ,
}
/* No side effect */
